import { EbookReaderLocation } from "../ebook-reader"
import { BaseProgressItem } from "./base"

type ProgressReadable = {
  percent: number
  finished: boolean
}

export type EbookProgressItemData = {
  contentType: "ebook"
  contentId: number
  progress?: ProgressReadable
  location?: EbookReaderLocation
}

export type WebEmbedProgressItemData = {
  contentType: "webEmbed"
  contentId: number
  progress?: ProgressReadable
}

export type ReadableProgressItemData =
  | EbookProgressItemData
  | WebEmbedProgressItemData

export class ReadableProgressItem<
  Data extends ReadableProgressItemData = ReadableProgressItemData,
> extends BaseProgressItem<Data, ProgressReadable> {
  getProgress = (): ProgressReadable => {
    const data = this.getData()
    return {
      percent: data.progress?.percent || 0,
      finished: data.progress?.finished || false,
    }
  }

  inProgress = () => {
    const progress = this.getProgress()
    return !progress.finished && progress.percent > 0
  }
}

export class EbookProgressItem extends ReadableProgressItem<EbookProgressItemData> {
  getLocation = (): EbookReaderLocation | undefined => this.getData().location
}

export class WebEmbedProgressItem extends ReadableProgressItem<WebEmbedProgressItemData> {}
